var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "badge badge-pill",
      class: {
        "badge-success": _vm.count > 0,
        "badge-secondary": _vm.count === 0,
      },
    },
    [_vm._v("\n    " + _vm._s(_vm.count) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }